import React from 'react';

/**
 * Icônes des boutons « voir » et « télécharger » d'un document : elles
 * remplacent les libellés « Voir » et « PDF » seuls, qui se confondaient dans
 * une rangée de boutons. L'œil consulte, la flèche télécharge ; le libellé
 * « PDF » les suit quand le document en est un.
 */
const attributs = {
  width: 14,
  height: 14,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true',
  focusable: 'false',
  style: { flexShrink: 0, verticalAlign: '-2px', marginRight: 5 },
};

/** Œil : voir / consulter. */
export function IconeOeil() {
  return (
    <svg {...attributs}>
      <path d="M1.5 12s3.8-7 10.5-7 10.5 7 10.5 7-3.8 7-10.5 7S1.5 12 1.5 12z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

/** Flèche descendant dans un bac : télécharger. */
export function IconeTelecharger() {
  return (
    <svg {...attributs}>
      <path d="M12 3v12" />
      <path d="M7 10.5l5 5 5-5" />
      <path d="M4 19.5h16" />
    </svg>
  );
}
